import { Button } from 'primeng/button';
import { AuthStore } from '@auth/stores/auth.store';
import { ChangeDetectionStrategy, Component, inject } from '@angular/core';

/**
 * Pantalla de destino seguro cuando el usuario autenticado no tiene accesos asignados.
 *
 * Se muestra cuando `userAccess()` está vacío tras login o refresco.
 * El usuario puede solicitar un refresco o contactar al administrador.
 */
@Component({
  selector: 'app-no-access-page',
  imports: [Button],
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <div class="flex min-h-screen flex-col items-center justify-center gap-6 bg-gray-50 p-8 dark:bg-slate-900">
      <div class="flex max-w-md flex-col items-center gap-4 text-center">
        <div class="flex size-16 items-center justify-center rounded-full bg-amber-100 text-amber-600 dark:bg-amber-900/30 dark:text-amber-400">
          <span class="pi pi-lock text-3xl"></span>
        </div>

        <div class="flex flex-col gap-2">
          <h1 class="text-2xl font-bold text-slate-900 dark:text-slate-100">
            Sin accesos asignados
          </h1>
          <p class="text-sm text-slate-500 dark:text-slate-400">
            Tu cuenta no tiene módulos habilitados aún. Contacta al administrador
            del sistema para que te asigne los permisos correspondientes.
          </p>
        </div>

        <div class="flex flex-col gap-3 w-full">
          <p-button
            label="Verificar accesos"
            icon="pi pi-refresh"
            [loading]="authStore.loading()"
            (onClick)="onRefresh()"
            styleClass="w-full" />

          <p-button
            label="Cerrar sesión"
            icon="pi pi-sign-out"
            variant="outlined"
            severity="secondary"
            (onClick)="onLogout()"
            styleClass="w-full" />
        </div>
      </div>
    </div>
  `,
})
export class NoAccessPage {
  readonly authStore = inject(AuthStore);

  onRefresh(): void {
    this.authStore.refreshMenu();
  }

  onLogout(): void {
    this.authStore.logout();
  }
}
